import { FC } from "react";
import { TableCell, TableRow, TextField } from "@mui/material";
import { DeviseInterface } from "../../content/parametrage/Article/InterfaceArticle";
import CheckAttr from "../../../utils/CheckAttr";
import { DataTaux } from "../../content/parametrage/TauxEchange/TauxDechange";

interface RowTauxDechangeFormAtribute {
  value: DataTaux;
  index: number;
  rowDevise: DeviseInterface;
  errorInput: number[];
  handleChangeTaux: (value: string, index: number) => void;
}

const TauxDechangeFormRow: FC<RowTauxDechangeFormAtribute> = ({
  value,
  index,
  rowDevise,
  handleChangeTaux,
  errorInput
}) => {

  const handleChange = (e: any) => handleChangeTaux(e.target.value, index);

  return (
    <>
      <TableRow>
        <TableCell align="center">{rowDevise?.monnaie}</TableCell>
        <TableCell align="center">
          <TextField
            name="tarif_acte"
            label="Taux"
            color="warning"
            fullWidth
            autoComplete="off"
            error={errorInput.includes(index)}
            value={value?.rate_euro}
            onChange={handleChange}
            InputLabelProps={{
              shrink: CheckAttr(value),
            }}
          />
        </TableCell>
      </TableRow>
    </>
  );
};

export default TauxDechangeFormRow;
